import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WhyFamilies from "@/components/WhyFamilies";
import Reviews from "@/components/Reviews";
import Program from "@/components/Program";
import Services from "@/components/Services";
import QuickReference from "@/components/QuickReference";
import Faqs from "@/components/Faqs";
import BookingSection from "@/components/BookingSection";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page">
      <Navbar />
      <Hero />
      <WhyFamilies />
      <Reviews />
      <Program />
      <Services />
      <QuickReference />
      <Faqs />
      <BookingSection />
      <Contact />
      <Footer />
    </main>
  );
}
